import type { ColumnConfig } from '@/components/configure-columns-dialog';

// Default column configuration for the Active Audits screen
// Note: 'title' column represents the combined Audit Title + Audit # column in the table
export const DEFAULT_ACTIVE_AUDITS_COLUMNS: ColumnConfig[] = [
  { id: 'title', label: 'Audit', visible: true, order: 0, group: 'default' },
  { id: 'type', label: 'Type', visible: true, order: 1, group: 'default' },
  { id: 'status', label: 'Status', visible: true, order: 2, group: 'default' },
  { id: 'priority', label: 'Priority', visible: true, order: 3, group: 'default' },
  { id: 'dueDate', label: 'Due Date', visible: true, order: 4, group: 'default' },
  { id: 'progress', label: 'Progress', visible: true, order: 5, group: 'default' },
  { id: 'assignedUsers', label: 'Assignees', visible: true, order: 6, group: 'default' },
];

export const ACTIVE_AUDITS_COLUMNS_STORAGE_KEY = 'active-audits-columns-config';
